import { HttpInterceptorFn } from '@angular/common/http';

export const AuthInterceptor: HttpInterceptorFn = (request, next) => {
	const authReq = request.clone({
		withCredentials: true,
	});

	return next(authReq);
};
